import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CommonDatagrid } from '..';
import { RefreshButton } from '../../Buttons/RefreshButton';
import { ProductStockSubscriptionsService } from '../../../api/services/productStockSubscriptionsService';
import { showNotification } from '../../../store/Reducers/NotificationSnackbarSlice';
import { IProductStockSubscriptionSummary } from '../../../types/api/response/productstocksubscriptionsresponse';
import { getProductStockSubscriptionsColumns } from './columns';

export const ProductStockSubscriptionsDatagrid = () => {
  const dispatch = useDispatch();
  const [subscriptions, setSubscriptions] = useState<IProductStockSubscriptionSummary[]>([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [totalElements, setTotalElements] = useState(0);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  const load = async (p = page, s = pageSize, q = search) => {
    setLoading(true);
    try {
      const res = await ProductStockSubscriptionsService.getPendingSubscriptions({
        ...(q ? { search: q } : {}),
        page: p,
        size: s,
      });
      setSubscriptions(res.content ?? []);
      setTotalElements(res.page?.totalElements ?? 0);
    } catch (e: any) {
      dispatch(
        showNotification({
          message: e?.response?.data?.message ?? 'Failed to load product stock subscriptions.',
          severity: 'error',
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(page, pageSize, search);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, search]);

  const handlePageSizeChange = (newSize: number) => {
    setPageSize(newSize);
    setPage(0);
  };

  const handleSearch = (q: string) => {
    setSearch(q.trim());
    setPage(0);
  };

  return (
    <CommonDatagrid
      data={subscriptions}
      columns={getProductStockSubscriptionsColumns()}
      rowId="sku"
      serverPagination
      page={page}
      pageSize={pageSize}
      rowCount={totalElements}
      loading={loading}
      onPageChange={setPage}
      onPageSizeChange={handlePageSizeChange}
      onChangeSearchKeyword={handleSearch}
      searchbarPlaceholder="Search by SKU or product name..."
      headerActionButtons={<RefreshButton onClick={() => load(page, pageSize, search)} />}
    />
  );
};
